import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { StorageService } from '@morningstar/shared/base/storage-service';
import { AccumulationChart } from '@syncfusion/ej2-charts';
import { CategoryService } from 'apps/wsg/src/app/shared/categories/category.service';
import { RevenueByCategoryDatum } from '../revenue-by-category-datum';
import { RevenueByCategorySelectors } from '../revenue-by-category.selectors';
import { RevenueByCategoryService } from '../revenue-by-category.service';
import { RevenueByCategoryComponent } from '../revenue-by-category/revenue-by-category.component';

@Component({
  selector: 'wsg-earned-revenue-donut',
  templateUrl: '../revenue-by-category/revenue-by-category.component.html',
  styleUrls: ['../../dashboard.scss', '../revenue-by-category/revenue-by-category.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ RevenueByCategoryService]
})
export class EarnedRevenueDonutComponent extends RevenueByCategoryComponent {

  chartId = 'earnedRevenueByCategoryChart'
  title = 'Earned Revenue By Category';
  options = { billedOrEarned: 'E' };
  @ViewChild('pie') pieChart: AccumulationChart;
  
  constructor(revenueByCategoryService: RevenueByCategoryService, formBuilder: FormBuilder, snackbar: MatSnackBar,
              categoryService: CategoryService, storageService: StorageService) {
    super(revenueByCategoryService, formBuilder, categoryService, storageService);
      
    this.onConcreteLoaded();
  }
  
  getSelector(): string { 
    return RevenueByCategorySelectors.earnedRevenueDonut; 
  }

  reloadChart(revenueTotal: RevenueByCategoryDatum[]) {
    if (this.pieChart) {
      this.pieChart.dataSource = revenueTotal;
      this.pieChart.refresh();
    }
  }
}
